import { isWeb } from './platform';
import { navigationRef } from './navigation';

export const serialize = (obj: Record<string, unknown>) => {
  var str: string[] = [];
  for (var p in obj) {
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(JSON.stringify(obj[p])));
    }
  }
  return str.join('&');
};

export const getParameterByName = (name: string) => {
  const url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return '';
  }
  return decodeURIComponent(results[2]);
};

export const formatOData = ({
  pageNumber,
  pageSize,
  count,
  orderBy,
  orderByDirection = 'asc',
  filter,
  select,
}: {
  pageNumber?: number;
  pageSize?: number;
  count?: boolean;
  orderBy?: string;
  orderByDirection?: string;
  filter?: Array<{ name: string; operator?: string; value?: string }> | Record<string, { operator: string; value: string } | string | null>;
  select?: string;
}) => {
  let str = '';

  if (pageSize) {
    str += `&$skip=${pageNumber * pageSize}&$top=${pageSize}`;
  }

  if (count) {
    str += `&$count=true`;
  }

  if (select) {
    str += `&$select=${select}`;
  }

  if (orderBy) {
    str += `&$orderby=${orderBy} ${orderByDirection}`;
  }

  if (filter) {
    let filterStr = '';
    if (Array.isArray(filter)) {
      filter.forEach((obj) => {
        if (filterStr) {
          filterStr += ' and ';
        }
        if (obj?.operator) {
          filterStr += `${obj.name} ${obj.operator} ${obj.value}`;
        } else {
          filterStr += `${obj.name} eq '${obj}'`;
        }
      });
    } else {
      Object.keys(filter).forEach((key) => {
        if (filter[key] !== null) {
          if (filterStr) {
            filterStr += ' and ';
          }
          if (filter[key]?.operator) {
            filterStr += `${key} ${filter[key].operator} ${filter[key].value}`;
          } else {
            filterStr += `${key} eq '${filter[key]}'`;
          }
        }
      });
    }
    if (filterStr) {
      str += `&$filter=${filterStr}`;
    }
  }

  return str;
};

export const splitIPAndPort = (input: string) => {
  let ipAddress = '';
  let port = '';

  // Check if input includes IPv6 format with port
  if (input.includes('[') && input.includes(']')) {
    const matches = input.match(/\[(.*?)\]:(\d+)$/);
    if (matches) {
      ipAddress = matches[1];
      port = matches[2];
    }
  } else if (input.includes(':')) {
    // Could be IPv4 with port or IPv6 without port
    const lastColon = input.lastIndexOf(':');

    // Check if input is IPv6 without port
    if (input.split(':').length > 2) {
      ipAddress = input; // Assuming it's a full IPv6 address without a port
    } else {
      // Assuming it's IPv4 with port
      ipAddress = input.substring(0, lastColon);
      port = input.substring(lastColon + 1);
    }
  } else {
    // No port included, just the IP
    ipAddress = input;
  }

  // Handling edge cases for IPv6 without port but containing multiple colons
  if (!port && ipAddress.includes(':') && ipAddress.split(':').length > 2) {
    // It's a pure IPv6 without brackets and port
    port = ''; // Confirming no port
  }

  return { ipAddress, port };
};

export const addQueryParams = (params: Record<string, string>) => {
  navigationRef?.current?.setParams(params);

  if (!isWeb) {
    return;
  }

  const currentUrl = new URL(window.location);
  Object.keys(params).forEach((key) => currentUrl.searchParams.set(key, params[key]));
  window.history.pushState({}, '', currentUrl);
};

export const removeQueryParam = (paramToRemove: string) => {
  navigationRef?.current?.setParams({ [paramToRemove]: undefined });

  if (!isWeb) {
    return;
  }
  const currentUrl = new URL(window.location);
  currentUrl.searchParams.delete(paramToRemove);
  window.history.pushState({}, '', currentUrl);
};
